export default "__VITE_ASSET__4745b343__"